import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonLibService, PageLoadingService } from '@lib/services';
import { CheckinBaseComponent } from '@common/components';
import { CHECKIN_ROUTES } from '@conf/routes.config';
import { CprResultStoreService } from '@common/services/cpr-result-store/cpr-result-store.service';
import { StandbyGetAlternativeOffersStoreService } from '@common/services';
import { CheckinCommonState } from '@common/store';
import { CheckinCommonStoreService } from '@common/services/checkin-common-store/checkin-common-store.service';
import { filter, map, pairwise, take } from 'rxjs';
import { Router } from '@angular/router';
import { PREVIOUS_PAGE_IDENTIFIER } from '@conf/previous-page-identifier.config';
import { LoadingDisplayMode } from '@lib/interfaces';

@Component({
  selector: 'asw-checkin-standby-flight-availability-sub-header',
  templateUrl: './checkin-standby-flight-availability-sub-header.component.html',
  styleUrls: ['./checkin-standby-flight-availability-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CprResultStoreService, StandbyGetAlternativeOffersStoreService],
})
export class CheckinStandbyFlightAvailabilitySubHeaderComponent extends CheckinBaseComponent {
  private checkinCommon?: CheckinCommonState = this.checkinCommonStoreService.checkinCommon;

  /** ブレッドクラムのステップ数保持のための変数 */
  public stepNum = 3;
  public currentStepNum = 1;

  constructor(
    private common: CommonLibService,
    private cprResultStoreService: CprResultStoreService,
    private standbyGetAlternativeOffersStoreService: StandbyGetAlternativeOffersStoreService,
    private checkinCommonStoreService: CheckinCommonStoreService,
    private router: Router,
    private pageLoadingService: PageLoadingService
  ) {
    super(common);
  }

  override reload(): void {}
  override init(): void {}

  /**
   * 戻るボタン押下イベント
   * @param event
   */
  onClickBackButton(event: Event) {
    event.preventDefault();
    // 規約画面を経由して遷移されてきた場合（チェックイン共通に変更前操作オフィスコード、変更前言語コード有）
    if (this.checkinCommon?.previousPointOfSaleId && this.checkinCommon.previousLang) {
      this.pageLoadingService.startLoading();
      // オフィス/言語変更APIを呼び出し、オフィス・言語を変更前の情報に更新する
      this.common.aswContextStoreService.changeLanguage(
        this.checkinCommon.previousLang,
        this.checkinCommon.previousPointOfSaleId
      );

      // オフィス言語更新APIの呼び出し完了を監視して、呼び出し完了後の処理を実施
      this.subscribeService(
        this.common.aswContextStoreService.getAswContext$().pipe(
          pairwise(),
          // 前の状態が呼び出し中かつ現在の状態が呼び出し中でないかつ呼び出しに失敗していないものだけ流す
          filter(([prev, curr]) => prev.isPending === true && curr.isPending === false && curr.isFailure === false),
          map(([_, curr]) => curr),
          take(1)
        ),
        (curr) => {
          // チェックイン共通の変更前操作オフィスコード、変更前言語情報をクリアする
          this.checkinCommonStoreService.updateCheckinCommon({
            previousPointOfSaleId: undefined,
            previousLang: undefined,
          });

          // 画面のローディング処理終了
          this.pageLoadingService.endLoading();

          // 遷移前共通処理実行後、チェックイン状況詳細画面（C02 - P010）に遷移
          this.screenTransitionCommonProcess();
        }
      );
    } else {
      // 遷移前共通処理実行後、チェックイン状況詳細画面（C02 - P010）に遷移
      this.screenTransitionCommonProcess();
    }
  }

  /**
   * 画面遷移共通処理
   */
  private screenTransitionCommonProcess() {
    // 遷移元画面の設定
    this.checkinCommonStoreService.updateCheckinCommon({
      previousPageIdentifier: PREVIOUS_PAGE_IDENTIFIER.CHECKIN_STANDBY_FLIGHT_AVAILABILITY,
    });
    // チェックイン状況詳細画面（C02 - P010）に遷移
    this.router.navigate([CHECKIN_ROUTES.checkinMybooking]);
  }

  override destroy(): void {
    // ストアのクリア
    this.cprResultStoreService.clearCprResult();
    this.standbyGetAlternativeOffersStoreService.clear();
  }
}
